import 'react-quill/dist/quill.bubble.css';

import React, { CSSProperties } from 'react';

import Box from '@mui/material/Box';
import { InlineQuillEdit } from '../InlineQuillEdit';
import LessonComponentService from '../../services/LessonComponentService';
import { LessonComponentStyleType } from '../../models/LessonComponentStyleType';
import { LessonContextConsumer } from '../../models/LessonContext';
import { TextComponent } from '../../models/LessonComponent';
import { cloneDeep } from 'lodash';
import componentStyles from '../../styles/LessonComponents.module.css';
import { useLessonEditContext } from '../../models/LessonEditContext';
import useThemes from '../../../shared/hooks/useThemes';

interface TextComponentProps {
  style?: CSSProperties;
  styleType: LessonComponentStyleType;
  component: TextComponent;
  placeholder?: string;
}

export function TextComponentView(props: TextComponentProps) {
  const { handleSettingsChange } = useLessonEditContext();
  const { muiTheme } = useThemes();
  const fontFamily =
    props.styleType === 'h1'
      ? muiTheme.typography.subtitle1.fontFamily
      : props.styleType === 'h2'
      ? muiTheme.typography.subtitle2.fontFamily
      : muiTheme.typography.fontFamily;
  function handleChange(value: string) {
    const copy = cloneDeep(props.component);
    copy.content.text = value;
    handleSettingsChange(copy);
  }

  return (
    <LessonContextConsumer>
      {({ mode }) => (
        <div style={{ fontFamily }} className={`style-${props.styleType}`}>
          <Box className={componentStyles.textOverflow}>
            {mode === 'edit' ? (
              <InlineQuillEdit
                placeholder={props.placeholder}
                value={props.component.content?.text}
                componentKey={props.component.componentkey}
                styleType={props.styleType}
                onChange={handleChange}
              />
            ) : (
              <span
                className="ql-editor"
                dangerouslySetInnerHTML={{
                  __html: LessonComponentService.getUrlWithSas(
                    props.component.content?.text
                  )
                }} //content.text has been sanitized before storing into db.
              ></span>
            )}
          </Box>
        </div>
      )}
    </LessonContextConsumer>
  );
}
